import React, { useEffect, useState } from "react";
import { deleteCampaign, getAllCampaigns } from "../../../api/campaigns.api";
import AdminLayout from "../../layout/AdminLayout";
import { baseURL } from "../../../api/api";
import { BsTrash3 } from "react-icons/bs";
import { Link, useLocation } from "react-router-dom";
import {
  confirmCampaignDelete,
  errorMsg,
  success,
} from "../../../utils/notifications";
import { FiPlus } from "react-icons/fi";
import { RotatingLines } from "react-loader-spinner";
function Campaigns() {
  const location = useLocation();
  const [campaignDetails, setCampaignDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(
    parseInt(localStorage.getItem("currentPage")) || 1
  );
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10; // Number of items per page

  useEffect(() => {
    localStorage.setItem("currentPage", currentPage); // Save page number
    // Restore page number if returning from campaign details
    const savedPage = localStorage.getItem("currentPage");
    if (savedPage) {
      setCurrentPage(parseInt(savedPage));
    }
  }, [location]); // Runs when route changes

  useEffect(() => {
    localStorage.setItem("currentPage", currentPage); // Save page number
    setLoading(true);
    getAllCampaigns(currentPage, limit)
      .then((res) => {
        setLoading(false);
        setCampaignDetails(res?.data?.campaigns || []);
        setTotalPages(res?.data?.totalPages || 1);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  }, [currentPage]);
  // Function to generate page numbers with ellipsis
  const generatePageNumbers = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1, 2, 3);
      if (currentPage > 5) pages.push("...");
      const middlePages = [
        currentPage - 1,
        currentPage,
        currentPage + 1,
      ].filter((p) => p > 3 && p < totalPages - 2);
      pages.push(...middlePages);
      if (currentPage < totalPages - 4) pages.push("...");
      pages.push(totalPages - 2, totalPages - 1, totalPages);
    }
    return pages;
  };

  const handleDelete = (id, e) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      confirmCampaignDelete().then(async (result) => {
        if (result.isConfirmed) {
          await deleteCampaign(id);
          setCampaignDetails(
            campaignDetails.filter((campaign) => campaign._id !== id)
          );
          await success("Success!", "Campaign deleted successfully!");
        }
      });
    } catch (error) {
      console.error("Error deleting campaign:", error);
      errorMsg("Oops", error?.response?.message);
    }
  };

  return (
    <>
      <AdminLayout title="Campaigns">
        <div className="p-5">
          <div className="flex items-center justify-end sticky  bg-slate-50 py-3 z-10 px-2">
            <Link
              to="/campaigns/add"
              className="flex items-center justify-center rounded-md bg-yellowColor px-3 py-2.5 text-base font-semibold text-gray-700 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellowColor"
            >
              {" "}
              <FiPlus className="text-lg text-gray-700" />
              Add Campaign
            </Link>
          </div>
          {loading ? (
            <div className="flex justify-center items-center h-64">
              <RotatingLines
                strokeColor="black"
                strokeWidth="5"
                animationDuration="0.75"
                width="96"
                visible={true}
              />
            </div>
          ) : campaignDetails.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-10">
              <p className="text-2xl text-gray-700 font-bold">
                No campaigns found. Please add a campaign.
              </p>
            </div>
          ) : (
            <div className="gap-7 grid grid-cols-12">
              {campaignDetails.map((campaign, index) => (
                <Link
                  to={`/campaigndetails/${campaign._id}`}
                  key={index}
                  className="lg:col-span-4 md:col-span-12 col-span-12"
                >
                  <div className="bg-white border border-gray-200 rounded-lg shadow">
                    <div className="px-5 py-3 flex items-center justify-end">
                      <button
                        id="delCampaign"
                        onClick={(e) => handleDelete(campaign._id, e)}
                        className="ml-3 text-xl h-8 w-8 flex items-center justify-center bg-red-100 text-red-700  px-0.5 rounded-md"
                      >
                        <BsTrash3 />
                      </button>
                    </div>
                    <video
                      className="hide-voice-control object-cover h-64 w-full"
                      alt=""
                      muted
                      controls
                    >
                      <source
                        src={`${baseURL}/s3/images/${campaign?.video?.name}`}
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                    <div className="py-5">
                      <div className="px-5 flex items-center justify-between">
                        <p className="text-xl font-semibold text-gray-700">
                          {campaign.name}
                        </p>
                        <p className="text-lg font-normal text-gray-600">
                          € {campaign?.totalCost}
                        </p>
                      </div>
                      <div className="px-5 pb-4 flex items-center justify-between">
                        <p className="text-base font-semibold text-gray-700">
                          Company Name
                        </p>
                        <p className="text-base font-semibold text-gray-600">
                          {campaign?.company?.name}
                        </p>
                      </div>
                      <div className="px-5 flex justify-between my-3">
                        <h1 className="text-gray-600 font-semibold text-base">
                          Campaign Status
                        </h1>
                        <span
                          className={`px-2 py-0.5 rounded ${
                            campaign?.status === "Pending Approval"
                              ? "bg-orange-100 text-orange-700"
                              : campaign?.status === "Approved"
                              ? "bg-green-100 text-green-700"
                              : campaign?.status === "Ongoing"
                              ? "bg-blue-100 text-blue-700"
                              : campaign?.status === "Ended"
                              ? "bg-red-100 text-red-700"
                              : "bg-gray-100 text-gray-800"
                          }  text-sm`}
                        >
                          {campaign?.status}
                        </span>
                      </div>
                      <div className="px-5 flex items-center justify-between">
                        <p className="text-base font-semibold text-gray-600">
                          Date
                        </p>
                        <p className="text-sm font-normal text-gray-600">
                          {campaign?.startDate.split("T")[0]} -{" "}
                          {campaign?.endDate.split("T")[0]}
                        </p>
                      </div>
                      <div className="px-5 flex items-center justify-between">
                        <p className="text-base font-semibold text-gray-600">
                          Number of Weeks
                        </p>
                        <p className="text-sm font-normal text-gray-600">
                          {campaign?.numberOfWeeks}
                        </p>
                      </div>
                      <div className="px-5 flex items-center justify-between">
                        <p className="text-base font-semibold text-gray-600">
                          Location
                        </p>
                        <p className="text-sm font-normal text-gray-600">
                          {campaign?.location}
                        </p>
                      </div>
                      <div className="px-5 flex items-center justify-between">
                        <p className="text-base font-semibold text-gray-600">
                          Number of Screens
                        </p>
                        <p className="text-sm font-normal text-gray-600">
                          {campaign?.numberOfScreens}
                        </p>
                      </div>
                      <div className="px-5 flex items-center justify-between">
                        <p className="text-base font-semibold text-gray-600">
                          Paid {campaign?.paid}
                        </p>
                        <p
                          className={`text-sm font-medium px-2 py-0.5 rounded ${
                            campaign?.paid
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-red-700"
                          }`}
                        >
                          {campaign?.paid ? "Yes" : "No"}
                        </p>
                      </div>
                      <div className="px-5 flex items-center justify-between">
                        <p className="text-base font-semibold text-gray-600">
                          Impressions
                        </p>
                        <p className="text-sm font-normal text-gray-600">
                          {campaign?.impressions}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
          {/* Pagination Controls */}
          {loading ? (
            <div className="flex justify-center items-center h-20"></div>
          ) : campaignDetails.length > 0 ? ( // Show pagination only if campaigns exist
            <div className="mt-5 flex justify-center items-center gap-2">
              {/* Previous Button */}
              <button
                className={`px-4 py-2 rounded ${
                  currentPage === 1
                    ? "bg-gray-300 cursor-not-allowed"
                    : "bg-yellow-500 text-black"
                }`}
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Previous
              </button>

              {/* Page Numbers */}
              {generatePageNumbers().map((page, index) =>
                page === "..." ? (
                  <button
                    key={index}
                    className="px-3 py-2 text-gray-600 bg-gray-300 rounded"
                  >
                    ...
                  </button>
                ) : (
                  <button
                    key={index}
                    className={`px-3 py-2 rounded ${
                      currentPage === page
                        ? "bg-yellow-500 text-black font-bold"
                        : "bg-gray-200 text-gray-700"
                    }`}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </button>
                )
              )}

              {/* Next Button */}
              <button
                className={`px-4 py-2 rounded ${
                  currentPage === totalPages
                    ? "bg-gray-300 cursor-not-allowed"
                    : "bg-yellow-500 text-black"
                }`}
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </button>
            </div>
          ) : null}{" "}
        </div>
      </AdminLayout>
    </>
  );
}

export default Campaigns;
